module.exports = __webpack_public_path__ + "static/media/merged-eds.11936fa1.png";